import React, { useRef, useState, useEffect } from "react";
import "./createnewnetwork.scss"
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Navbar from '../landing/header/Navbar';
import { Link, NavLink } from "react-router-dom";
import Table from 'react-bootstrap/Table';
import Pagination from 'react-bootstrap/Pagination';
import { api_url } from "../../utils/Enviroment";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { useWeb3React } from "@web3-react/core";
import Loader from '../../loader';
import { formatEthinDollar, formatMarketCap, getTimeInAges } from "../../utils/helpers";
import { ethToDollarConverter } from "../../utils/services/service";
import Footernew from "../landing/footernew/Footernew";

const Createnewnetwork = () => {


    let { account } = useWeb3React();
    const fileInputRef = useRef(null);
    const [profile, setProfile] = useState(null);
    const [loader, setLoader] = useState(false);
    const [editDisabled, setEditDisabled] = useState(false);
    const [name, setName] = useState(null);
    const [lastUserName, setLastUserName] = useState(null);
    const [projectBannerImg, setProjectBannerImg] = useState("");
    const [logoFile, setLogoFile] = useState(null);
    const [tokenCreated, setTokenCreated] = useState([]);
    const [tokenHeld, setTokenHeld] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [totalItems, setTotalItems] = useState(0);
    const [currentPageHeld, setCurrentPageHeld] = useState(1);
    const [totalPagesHeld, setTotalPagesHeld] = useState(0);
    const [totalItemsHeld, setTotalItemsHeld] = useState(0);
    const [ethPrice, setEthPrice] = useState(0);

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);  // Set the currentPage to the selected page
        }
    };

    const pageItems = [];
    for (let i = 1; i <= totalPages; i++) {
        pageItems.push(i);  // Create an array of page numbers
    }

    const handlePageChangeHeld = (pageHeld) => {
        if (pageHeld >= 1 && pageHeld <= totalPagesHeld) {
            setCurrentPageHeld(pageHeld);  // Set the currentPage to the selected page
        }
    };

    const pageItemsHeld = [];
    for (let i = 1; i <= totalPagesHeld; i++) {
        pageItemsHeld.push(i);  // Create an array of page numbers
    }


    const handleImageUpload = (event) => {
        const file = event.target.files[0];

        if (file) {
            const validTypes = ["image/jpeg", "image/png", "image/gif"];
            if (!validTypes.includes(file.type)) {
                toast.error("Incorrect Image Type");
                return;
            }
            if (file.size > 5 * 1024 * 1024) {
                toast.error("Image must be less than 5MB");
                return;
            }
            const fileName = file.name.replace(/\s+/g, "_");
            const newFile = new File([file], fileName, { type: file.type });
            const imageUrl = URL.createObjectURL(newFile);
            const formData = new FormData();
            formData.append("image", newFile);

            setLogoFile(formData);
            setProjectBannerImg(imageUrl);
        }
    };


    const handleButtonClick = () => {
        document.getElementById("imageUploadInput").click(); // Trigger the hidden file input
    };
    const textRef = useRef(null); // Reference to the h4 element
    const [copied, setCopied] = useState(false); // State to show "Copied" message



    const handleCopy = () => {
        if (profile?.walletAddress) {
            if (navigator.clipboard) {
                navigator.clipboard.writeText(profile?.walletAddress)
                    .then(() => {
                        setCopied(true);
                        setTimeout(() => setCopied(false), 2000);
                    })
                    .catch((err) => { });
            } else {
                // Fallback for unsupported environments
                const textArea = document.createElement("textarea");
                textArea.value = profile?.walletAddress;
                document.body.appendChild(textArea);
                textArea.select();
                try {
                    document.execCommand('copy');
                    setCopied(true);
                    setTimeout(() => setCopied(false), 2000);
                } catch (err) {
                    console.error("Failed to copy URL using fallback:", err);
                }
                document.body.removeChild(textArea);
            }
        }
    };

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const getProfile = async () => {
        const token = localStorage?.getItem("accessToken");
        try {
            const { data } = await axios.get(`${api_url}user/get-user-profile/${account}`, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                },
            });
            setProfile(data?.data)
            setName(data?.data?.alias)
            setLastUserName(data?.data?.alias)
            setProjectBannerImg(data?.data?.pfp)
        } catch (error) {
            // console.error("Error fetching gift collections:", error);

        }
    };

    const getTokenCreated = async () => {
        const token = localStorage?.getItem("accessToken");
        try {
            const { data } = await axios.get(`${api_url}project/get-user-projects/${account}?limit=10&page=${currentPage}`, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                },
            });
            const updatedProjects = data?.data?.projects?.map(project => {
                const updatedTime = project?.createdAt;
                const lastUpdated = updatedTime
                    ? getTimeInAges(updatedTime)
                    : "Unknown time";
                return {
                    ...project,
                    lastUpdated,
                };
            })
            setTokenCreated(updatedProjects)
            setTotalPages(data?.data?.totalPages);
            setTotalItems(data?.data?.total);
        } catch (error) {
            console.error("Error fetching gift collections:", error);
        }
    };


    const getTokenHeld = async () => {
        const token = localStorage?.getItem("accessToken");
        try {
            const { data } = await axios.get(`${api_url}user/get-user-coin-held/${account}?limit=10&page=${currentPageHeld}`, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                },
            });
            const updatedProjects = data?.data?.tokens?.map(project => {
                const updatedTime = project?.createdAt;
                const lastUpdated = updatedTime
                    ? getTimeInAges(updatedTime)
                    : "Unknown time";
                return {
                    ...project,
                    lastUpdated,
                };
            })
            setTokenHeld(updatedProjects)
            setTotalPagesHeld(data?.data?.totalPages);
            setTotalItemsHeld(data?.data?.totalUserHeldTokens);
        } catch (error) {
            console.error("Error fetching gift collections:", error);
        }
    };

    useEffect(() => {
        if (account) {
            getProfile();

        }
    }, [account]);

    useEffect(() => {
        if (account) {
            getTokenCreated();
        }
    }, [currentPage, account])

    useEffect(() => {
        if (account) {
            getTokenHeld();
        }
    }, [currentPageHeld, account])

    const updateProfile = async (imageUrl) => {
        const token = localStorage?.getItem("accessToken");
        try {
            const payload = {
                walletAddress: account,
                pfp: imageUrl
            };
            if (name && name != lastUserName) {
                payload.alias = name;
            }
            const response = await axios.patch(
                `${api_url}user/update-user-profile`,
                payload,
                {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                    },
                }
            );
            if (response) {
                getProfile();
                handleClose();
                setEditDisabled(false)
                setLoader(false);
                toast.success('Profile updated successfully!');
            }
        } catch (error) {
            console.error('Update failed:', error);
            toast.error('Username already exists!');
            setEditDisabled(false)
            setLoader(false);
        }
    };

    const editProfile = async () => {
        if (name?.length < 3) {
            toast.error("Name must be min 3 characters");
            return;
        }
        setLoader(true);
        const token = localStorage?.getItem("accessToken");
        setEditDisabled(true)
        try {
            if (logoFile) {
                const fileUpload = await axios.post(`${api_url}file/upload`, logoFile, {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                    },
                });
                if (fileUpload?.data) {
                    await updateProfile(fileUpload?.data)
                }

            } else {
                await updateProfile(profile?.pfp)
            }
        } catch (error) {
            console.error('Registration failed:', error);
            setEditDisabled(false)
            setLoader(false);
        }
    };

    const fetchEthValue = async () => {
        const ethAmount = await ethToDollarConverter();
        setEthPrice(ethAmount);
    };

    useEffect(() => {
        fetchEthValue()
    }, []);
    return (
        <>
            {loader && <Loader />}
            <Navbar />
            <section className='createnewtoken'>
                <div className='custom-container'>
                    <div className='edit_profile'>
                        <div className='top_edit'>
                            <video className='main-banner-video'
                                muted="muted" playsinline="playsinline"
                                autoPlay
                                loop
                                width="100%"
                                id="myVideo">
                                <source src="https://d381ze7vrxmjbo.cloudfront.net/gifs/bannervideo.mp4" type="video/mp4" />
                            </video>
                            <div className='innner_edit'>
                                <img className="profileimggg" src={profile?.pfp ? profile?.pfp : '/asset/profileee.svg'} />
                                <div>
                                    <h1>{profile?.alias ? profile?.alias : "anonymous"}</h1>
                                    <div>
                                        <p ref={textRef}>
                                            {profile?.walletAddress?.slice(0, 6)}...{profile?.walletAddress?.slice(-4)}
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="14"
                                                height="15"
                                                viewBox="0 0 14 15"
                                                fill="none"
                                                onClick={handleCopy} // Handle click event
                                                style={{ cursor: "pointer" }}
                                            >
                                                {copied ? (
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                        <path d="M12 3L5.125 10L2 6.81818" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                ) : (
                                                    <g clipPath="url(#clip0_142_10541)">
                                                        <path d="M11.667 5.16675H5.83366C5.18933 5.16675 4.66699 5.68908 4.66699 6.33341V12.1667C4.66699 12.8111 5.18933 13.3334 5.83366 13.3334H11.667C12.3113 13.3334 12.8337 12.8111 12.8337 12.1667V6.33341C12.8337 5.68908 12.3113 5.16675 11.667 5.16675Z" stroke="#F2F2F2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M2.33366 9.83342C1.69199 9.83342 1.16699 9.30842 1.16699 8.66675V2.83341C1.16699 2.19175 1.69199 1.66675 2.33366 1.66675H8.16699C8.80866 1.66675 9.33366 2.19175 9.33366 2.83341" stroke="#F2F2F2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    </g>
                                                )}
                                                <defs>
                                                    <clipPath id="clip0_142_10541">
                                                        <rect width="14" height="14" fill="white" transform="translate(0 0.5)" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </p>
                                    </div>
                                    <p></p>
                                </div>
                            </div>
                            <button onClick={handleShow}>Edit Profile</button>
                        </div>
                        <div className='edit_tabs'>
                            <div class="d-flex align-items-start sellbuy_tab">
                                <div className='tabbbs_data '>
                                    <div class="nav  nav-pills  tabbss_div" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                                        <button class="nav-link active" id="v-pills-homee-tab" data-bs-toggle="pill" data-bs-target="#v-pills-homee" type="button" role="tab" aria-controls="v-pills-homee" aria-selected="true">Names Holding</button>
                                        <button class="nav-link" id="v-pills-profilee-tab" data-bs-toggle="pill" data-bs-target="#v-pills-profilee" type="button" role="tab" aria-controls="v-pills-profilee" aria-selected="false">Names Created</button>
                                    </div>
                                </div>
                                <div className='tabs__lower'>
                                    <div class="tab-content" id="v-pills-tabContent">
                                        <div class="tab-pane fade show active mydatttta" id="v-pills-homee" role="tabpanel" aria-labelledby="v-pills-homee-tab">
                                            <div className="tabone_Data">
                                                <Table responsive>
                                                    <thead>
                                                        <tr>

                                                            <th>
                                                                <div className="leftside">
                                                                    <div className="thdata">
                                                                        <p>Name</p>
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="8" viewBox="0 0 6 8" fill="none">
                                                                            <path d="M5.2727 4.57129H2.72997H0.440293C0.0484758 4.57129 -0.147433 5.09169 0.130104 5.39675L2.24428 7.72058C2.58304 8.09294 3.13403 8.09294 3.47279 7.72058L4.27683 6.83681L5.58697 5.39675C5.86043 5.09169 5.66452 4.57129 5.2727 4.57129Z" fill="#C3BDBC" />
                                                                            <path d="M5.2727 3.42877H2.72997H0.440293C0.0484758 3.42877 -0.147433 2.90838 0.130104 2.60332L2.24428 0.279478C2.58304 -0.0928748 3.13403 -0.0928748 3.47279 0.279478L4.27683 1.16325L5.58697 2.60332C5.86043 2.90838 5.66452 3.42877 5.2727 3.42877Z" fill="#C3BDBC" />
                                                                        </svg>
                                                                    </div>
                                                                </div>
                                                            </th>


                                                            <th >
                                                                <div className="thdata">
                                                                    <p>Age</p>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="8" viewBox="0 0 6 8" fill="none">
                                                                        <path d="M5.2727 4.57129H2.72997H0.440293C0.0484758 4.57129 -0.147433 5.09169 0.130104 5.39675L2.24428 7.72058C2.58304 8.09294 3.13403 8.09294 3.47279 7.72058L4.27683 6.83681L5.58697 5.39675C5.86043 5.09169 5.66452 4.57129 5.2727 4.57129Z" fill="#C3BDBC" />
                                                                        <path d="M5.2727 3.42877H2.72997H0.440293C0.0484758 3.42877 -0.147433 2.90838 0.130104 2.60332L2.24428 0.279478C2.58304 -0.0928748 3.13403 -0.0928748 3.47279 0.279478L4.27683 1.16325L5.58697 2.60332C5.86043 2.90838 5.66452 3.42877 5.2727 3.42877Z" fill="#C3BDBC" />
                                                                    </svg>
                                                                </div>
                                                            </th>
                                                            <th>
                                                                <div className="thdata">
                                                                    <p>Balance</p>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="8" viewBox="0 0 6 8" fill="none">
                                                                        <path d="M5.41552 4.57129H2.8728H0.583115C0.191298 4.57129 -0.00461033 5.09169 0.272927 5.39675L2.38711 7.72058C2.72586 8.09294 3.27686 8.09294 3.61562 7.72058L4.41966 6.83681L5.72979 5.39675C6.00325 5.09169 5.80734 4.57129 5.41552 4.57129Z" fill="#C3BDBC" />
                                                                        <path d="M5.41552 3.42877H2.8728H0.583115C0.191298 3.42877 -0.00461033 2.90838 0.272927 2.60332L2.38711 0.279478C2.72586 -0.0928748 3.27686 -0.0928748 3.61562 0.279478L4.41966 1.16325L5.72979 2.60332C6.00325 2.90838 5.80734 3.42877 5.41552 3.42877Z" fill="#C3BDBC" />
                                                                    </svg>
                                                                </div></th>
                                                            <th>    <div className="thdata">
                                                                <p className="marketcap">Market Cap</p>
                                                                <p className="mcap d-none">MCAP</p>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="7" height="8" viewBox="0 0 7 8" fill="none">
                                                                    <path d="M5.91552 4.57129H3.3728H1.08312C0.691298 4.57129 0.49539 5.09169 0.772927 5.39675L2.88711 7.72058C3.22586 8.09294 3.77686 8.09294 4.11562 7.72058L4.91966 6.83681L6.22979 5.39675C6.50325 5.09169 6.30734 4.57129 5.91552 4.57129Z" fill="#C3BDBC" />
                                                                    <path d="M5.91552 3.42877H3.3728H1.08312C0.691298 3.42877 0.49539 2.90838 0.772927 2.60332L2.88711 0.279478C3.22586 -0.0928748 3.77686 -0.0928748 4.11562 0.279478L4.91966 1.16325L6.22979 2.60332C6.50325 2.90838 6.30734 3.42877 5.91552 3.42877Z" fill="#C3BDBC" />
                                                                </svg>
                                                            </div></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            tokenHeld && tokenHeld?.length > 0 ? (
                                                                tokenHeld?.map((item, index) => {
                                                                    return (
                                                                        <>
                                                                            <tr key={index}>

                                                                                <td>
                                                                                    <div className="leftside">
                                                                                        <Link to={`/coin/${item?._id}`} >
                                                                                            <div className="inner_td">
                                                                                                <div>
                                                                                                    <h1>{item?.projectName}</h1>
                                                                                                </div>
                                                                                            </div>
                                                                                        </Link>
                                                                                    </div>
                                                                                </td>


                                                                                <td>
                                                                                    <h3>{item?.lastUpdated}</h3>
                                                                                </td>
                                                                                <td>
                                                                                    <h3> {`${formatMarketCap(+item?.balance)}`}</h3>
                                                                                </td>
                                                                                <td>
                                                                                    <h3> {`$${formatEthinDollar(+item?.marketcap, ethPrice)}`}</h3>
                                                                                </td>
                                                                            </tr>
                                                                        </>
                                                                    )
                                                                })
                                                            )
                                                                :

                                                                <p className="datafound">No Data Found!</p>

                                                        }
                                                    </tbody>
                                                </Table>
                                                <div className="pagination_mains">

                                                    <div>
                                                        <h6>SHOWING {(currentPageHeld - 1) * 10 + 1}-{Math.min(currentPageHeld * 10, totalItemsHeld)} OF {totalItemsHeld}</h6>
                                                    </div>
                                                    <div className="innner_pagi">
                                                        <Pagination >
                                                            {
                                                                +currentPageHeld > 1 &&
                                                                <div className='rightsideee'>
                                                                    <img
                                                                        src="/asset/leftarrow.svg"
                                                                        onClick={() => handlePageChangeHeld(currentPageHeld - 1)}
                                                                        style={{ cursor: 'pointer' }}
                                                                        className='imggggggright'
                                                                    />
                                                                </div>
                                                            }

                                                            {/* Ellipsis for skipped pages */}
                                                            {currentPageHeld > 5 && <Pagination.Ellipsis />}

                                                            {/* Dynamic Page Numbers */}
                                                            {pageItemsHeld.slice(Math.max(currentPageHeld - 3, 0), Math.min(currentPageHeld + 2, totalPagesHeld - 1)).map((page) => (
                                                                <Pagination.Item
                                                                    key={page}
                                                                    active={page === currentPageHeld}
                                                                    onClick={() => handlePageChangeHeld(page)}
                                                                >
                                                                    {page}
                                                                </Pagination.Item>
                                                            ))}

                                                            {/* Ellipsis for skipped pages */}
                                                            {currentPageHeld < totalPagesHeld - 2 && <Pagination.Ellipsis />}

                                                            {/* Last Page Button */}
                                                            {totalPagesHeld > 1 && (
                                                                <Pagination.Item active={+totalPagesHeld === +currentPageHeld} onClick={() => handlePageChangeHeld(totalPagesHeld)}>
                                                                    {totalPagesHeld}
                                                                </Pagination.Item>
                                                            )}

                                                            {/* Next Page Button */}
                                                            {
                                                                +totalPagesHeld != +currentPageHeld &&
                                                                <div className='rightsideee'>
                                                                    <img
                                                                        src="/asset/rightarrow.svg"
                                                                        onClick={() => handlePageChangeHeld(currentPageHeld + 1)}
                                                                        style={{ cursor: 'pointer' }}
                                                                        className='imggggggright'
                                                                    />
                                                                </div>
                                                            }

                                                        </Pagination>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade" id="v-pills-profilee" role="tabpanel" aria-labelledby="v-pills-profilee-tab">
                                            <div className="tabone_Data">
                                                <Table responsive>
                                                    <thead>

                                                        <tr>

                                                            <th>
                                                                <div className="leftside">
                                                                    <div className="thdata">
                                                                        <p>Names</p>
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="8" viewBox="0 0 6 8" fill="none">
                                                                            <path d="M5.2727 4.57129H2.72997H0.440293C0.0484758 4.57129 -0.147433 5.09169 0.130104 5.39675L2.24428 7.72058C2.58304 8.09294 3.13403 8.09294 3.47279 7.72058L4.27683 6.83681L5.58697 5.39675C5.86043 5.09169 5.66452 4.57129 5.2727 4.57129Z" fill="#C3BDBC" />
                                                                            <path d="M5.2727 3.42877H2.72997H0.440293C0.0484758 3.42877 -0.147433 2.90838 0.130104 2.60332L2.24428 0.279478C2.58304 -0.0928748 3.13403 -0.0928748 3.47279 0.279478L4.27683 1.16325L5.58697 2.60332C5.86043 2.90838 5.66452 3.42877 5.2727 3.42877Z" fill="#C3BDBC" />
                                                                        </svg>
                                                                    </div>
                                                                </div>
                                                            </th>


                                                            <th>
                                                                <div className="thdata">
                                                                    <p>Age</p>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="8" viewBox="0 0 6 8" fill="none">
                                                                        <path d="M5.41552 4.57129H2.8728H0.583115C0.191298 4.57129 -0.00461033 5.09169 0.272927 5.39675L2.38711 7.72058C2.72586 8.09294 3.27686 8.09294 3.61562 7.72058L4.41966 6.83681L5.72979 5.39675C6.00325 5.09169 5.80734 4.57129 5.41552 4.57129Z" fill="#C3BDBC" />
                                                                        <path d="M5.41552 3.42877H2.8728H0.583115C0.191298 3.42877 -0.00461033 2.90838 0.272927 2.60332L2.38711 0.279478C2.72586 -0.0928748 3.27686 -0.0928748 3.61562 0.279478L4.41966 1.16325L5.72979 2.60332C6.00325 2.90838 5.80734 3.42877 5.41552 3.42877Z" fill="#C3BDBC" />
                                                                    </svg>
                                                                </div></th>
                                                            <th>
                                                                <div className="thdata">
                                                                    <p>Balance</p>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="8" viewBox="0 0 6 8" fill="none">
                                                                        <path d="M5.41552 4.57129H2.8728H0.583115C0.191298 4.57129 -0.00461033 5.09169 0.272927 5.39675L2.38711 7.72058C2.72586 8.09294 3.27686 8.09294 3.61562 7.72058L4.41966 6.83681L5.72979 5.39675C6.00325 5.09169 5.80734 4.57129 5.41552 4.57129Z" fill="#C3BDBC" />
                                                                        <path d="M5.41552 3.42877H2.8728H0.583115C0.191298 3.42877 -0.00461033 2.90838 0.272927 2.60332L2.38711 0.279478C2.72586 -0.0928748 3.27686 -0.0928748 3.61562 0.279478L4.41966 1.16325L5.72979 2.60332C6.00325 2.90838 5.80734 3.42877 5.41552 3.42877Z" fill="#C3BDBC" />
                                                                    </svg>
                                                                </div></th>
                                                            <th>    <div className="thdata">
                                                                <p className="marketcap">Market Cap</p>
                                                                <p className="mcap d-none">MCAP</p>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="7" height="8" viewBox="0 0 7 8" fill="none">
                                                                    <path d="M5.91552 4.57129H3.3728H1.08312C0.691298 4.57129 0.49539 5.09169 0.772927 5.39675L2.88711 7.72058C3.22586 8.09294 3.77686 8.09294 4.11562 7.72058L4.91966 6.83681L6.22979 5.39675C6.50325 5.09169 6.30734 4.57129 5.91552 4.57129Z" fill="#C3BDBC" />
                                                                    <path d="M5.91552 3.42877H3.3728H1.08312C0.691298 3.42877 0.49539 2.90838 0.772927 2.60332L2.88711 0.279478C3.22586 -0.0928748 3.77686 -0.0928748 4.11562 0.279478L4.91966 1.16325L6.22979 2.60332C6.50325 2.90838 6.30734 3.42877 5.91552 3.42877Z" fill="#C3BDBC" />
                                                                </svg>
                                                            </div></th>
                                                            <th>    <div className="thdata">
                                                                <p>Holders</p>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="6" height="8" viewBox="0 0 6 8" fill="none">
                                                                    <path d="M5.41552 4.57129H2.8728H0.583115C0.191298 4.57129 -0.00461033 5.09169 0.272927 5.39675L2.38711 7.72058C2.72586 8.09294 3.27686 8.09294 3.61562 7.72058L4.41966 6.83681L5.72979 5.39675C6.00325 5.09169 5.80734 4.57129 5.41552 4.57129Z" fill="#C3BDBC" />
                                                                    <path d="M5.41552 3.42877H2.8728H0.583115C0.191298 3.42877 -0.00461033 2.90838 0.272927 2.60332L2.38711 0.279478C2.72586 -0.0928748 3.27686 -0.0928748 3.61562 0.279478L4.41966 1.16325L5.72979 2.60332C6.00325 2.90838 5.80734 3.42877 5.41552 3.42877Z" fill="#C3BDBC" />
                                                                </svg>
                                                            </div></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            tokenCreated && tokenCreated?.length > 0 ? (
                                                                tokenCreated?.map((item, index) => {
                                                                    return (
                                                                        <>
                                                                            <tr key={index}>

                                                                                <td>
                                                                                    <div className="leftside">
                                                                                        <Link to={`/coin/${item?._id}`}>
                                                                                            <div className="inner_td">
                                                                                                <div>
                                                                                                    <h1>{item?.projectName}</h1>
                                                                                                </div>
                                                                                            </div>
                                                                                        </Link>
                                                                                    </div>

                                                                                </td>

                                                                                <td>
                                                                                    <h3>{item?.lastUpdated}</h3>
                                                                                </td>
                                                                                <td>
                                                                                    <h3> {`${formatMarketCap(+item?.balance)}`}</h3>
                                                                                </td>
                                                                                <td>
                                                                                    <h3> {`$${formatEthinDollar(+item?.marketcap, ethPrice)}`}</h3>
                                                                                </td>
                                                                                <td>
                                                                                    <h3>{item?.totalHolders >= 0 ? item?.totalHolders : "--"}</h3>
                                                                                </td>
                                                                            </tr>
                                                                        </>
                                                                    )
                                                                })
                                                            )
                                                                :
                                                                <p className="datafound">No Data Found!</p>
                                                        }
                                                    </tbody>
                                                </Table>
                                                <div className="pagination_mains">

                                                    <div>
                                                        <h6>SHOWING {(currentPage - 1) * 10 + 1}-{Math.min(currentPage * 10, totalItems)} OF {totalItems}</h6>
                                                    </div>
                                                    <div className="innner_pagi">
                                                        <Pagination >
                                                            {
                                                                +currentPage > 1 &&
                                                                <div className='rightsideee'>
                                                                    <img
                                                                        src="/asset/leftarrow.svg"
                                                                        onClick={() => handlePageChange(currentPage - 1)}
                                                                        style={{ cursor: 'pointer' }}
                                                                        className='imggggggright'
                                                                    />
                                                                </div>
                                                            }
                                                            {currentPage > 5 && <Pagination.Ellipsis />}
                                                            {pageItems.slice(Math.max(currentPage - 3, 0), Math.min(currentPage + 2, totalPages - 1)).map((page) => (
                                                                <Pagination.Item
                                                                    key={page}
                                                                    active={page === +currentPage}
                                                                    onClick={() => handlePageChange(page)}
                                                                >
                                                                    {page}
                                                                </Pagination.Item>
                                                            ))}
                                                            {currentPage < totalPages - 2 && <Pagination.Ellipsis />}
                                                            {totalPages > 1 && (
                                                                <Pagination.Item active={+currentPage === +totalPages} onClick={() => handlePageChange(totalPages)}>
                                                                    {totalPages}
                                                                </Pagination.Item>
                                                            )}
                                                            {
                                                                +totalPages != +currentPage &&
                                                                <div className='rightsideee'>
                                                                    <img
                                                                        src="/asset/rightarrow.svg"
                                                                        onClick={() => handlePageChange(currentPage + 1)}
                                                                        style={{ cursor: 'pointer' }}
                                                                        className='imggggggright'
                                                                    />
                                                                </div>
                                                            }

                                                        </Pagination>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footernew />
            <Modal className='token' show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Profile</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='parent'>
                        <div className='top_modal'>
                            {projectBannerImg ? <img src={projectBannerImg} alt='img' className='img-fluid innerimage' /> : <img src='\asset\profileee.svg' alt='img' className='img-fluid innerimage' />}


                            <div>
                                <h1>Profile Image</h1>
                                <p>We recommend to upload images in 400x400 resolution. Max 5 MB in JPEG or PNG format</p>
                                <div className='bothbuttons'>
                                    <div className="butttons_changes">
                                        <div>
                                            <button className="Change" onClick={handleButtonClick}>
                                                Change
                                            </button>
                                            {/* Hidden file input */}
                                            <input
                                                id="imageUploadInput"
                                                type="file"
                                                accept="image/*"
                                                style={{ display: "none" }} // Hide the input element
                                                onChange={handleImageUpload}
                                                ref={fileInputRef}
                                            />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <h3>Full Name</h3>
                        <input type="text" id="fname" maxLength={24} name="fname" placeholder='Name' value={name} onChange={(e) => setName(e?.target?.value)} />
                        <h3>Wallet Address</h3>
                        <div>
                            <h4 ref={textRef}>
                                {profile?.walletAddress?.slice(0, 15)}..........{profile?.walletAddress?.slice(-5)}
                                <svg
                                    onClick={handleCopy} // Handle click event
                                    style={{ cursor: "pointer" }} // Add margin for spacing
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    viewBox="0 0 12 12"
                                    fill="none"
                                >
                                    {copied ? (
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                            <path d="M12 3L5.125 10L2 6.81818" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    ) : (
                                        <g clipPath="url(#clip0_168_2044)">
                                            <path d="M10 4H5C4.44772 4 4 4.44772 4 5V10C4 10.5523 4.44772 11 5 11H10C10.5523 11 11 10.5523 11 10V5C11 4.44772 10.5523 4 10 4Z" stroke="#191919" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M2 8C1.45 8 1 7.55 1 7V2C1 1.45 1.45 1 2 1H7C7.55 1 8 1.45 8 2" stroke="#191919" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </g>
                                    )}
                                    <defs>
                                        <clipPath id="clip0_168_2044">
                                            <rect width="12" height="12" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </h4>
                        </div>
                        <div className='botttthbutons'>
                            <button className='Cancel' onClick={handleClose}>Cancel</button>
                            <button className='SaveChanges' disabled={editDisabled} onClick={editProfile}>Save Changes</button>
                        </div>
                    </div>

                </Modal.Body>

            </Modal>
        </>
    )
}

export default Createnewnetwork